import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTableHeader } from '../../../../../core/components/Table/types/DataTableHeader';
import { DataTable, emptyDataTable } from '../../../../../core/components/Table/types/DataTable';
import ApiProvider from '../../../../../core/api/ApiProvider';
import { ResponseApiType } from '../../../../types/ResponseApiType';
import { Table, Loader } from '../../../../../core/components';
import { InfoMessageService, TranslationService } from '../../../../../core/services';

const CustomerTransactionActivities = () => {
  const { invoiceNo, creditorNo, accountNo, debtorNo, tenantUId } = useParams() as {
    invoiceNo: string;
    creditorNo: string;
    accountNo: string;
    debtorNo: string;
    tenantUId: string
  };
  const [table, setTable] = useState<DataTable>({ ...emptyDataTable });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pageSizeLimit, setPageSizeLimit] = useState<number>(10);

  const fetchActivities = async () => {
    try {
      const result = await ApiProvider.post<
        ResponseApiType<{ rowsLimit: number; headers: DataTableHeader[]; dataRows: any[] }>
      >('CustomerTransactionActivitiesModule/GetActivities', {
        AccountNo: accountNo,
        CreditorNo: creditorNo,
        InvoiceNo: invoiceNo,
        DebtorNo: debtorNo,
        SourceTenantId: tenantUId
      });

      if (result.success) {
        const rows = result.data.dataRows.map((h: any, index: number) => ({
          ...h,
          Id: `${h.columnName}${index}`,
        }));

        const headers = result.data.headers.map((h) => ({
          ...h,
          cssClassNames: `${!h.isVisible && 'hide-d'} ${!h.isVisibleOnMobile && 'hide-m'}`,
        }));

        headers.push({
          columnName: 'Id',
          headerName: '',
          isVisible: false,
          cssClassNames: '',
        });

        setTable({
          headers: headers,
          dataRows: rows,
        });
        setPageSizeLimit(result.data.rowsLimit);
      } else {
        throw result.message;
      }
    } catch (err) {
      InfoMessageService.error(
        (err as string) || TranslationService.translate('ErrorSthWentWrong')
      );
    } finally {
      setIsLoading(false);
    }
  };

  // @ts-ignore
  useEffect(() => {
    let isSubscribed = true;

    (async () => {
      await fetchActivities();

      if (isSubscribed) {
        setIsLoading(false);
      }
    })();

    return () => (isSubscribed = false);
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Table
            headers={table.headers}
            rows={table.dataRows}
            keyField="Id"
            paginationProps={{
              hideSizePerPage: true,
              hidePageListOnlyOnePage: true,
              sizePerPage: pageSizeLimit,
            }}
          />
        </>
      )}
    </>
  );
};

export default CustomerTransactionActivities;
